import { requireStates, ConnectComponent2 } from "util";
import View from "./view";
import Presenter from "./presenter";
import Sidebar from "components/support/sidebar";
import Topbar from "components/support/topbar";

const initialStates = [
  {
    name: "app.support.company.show",
    url: "/:companyUuid",
    views: {
      "sidebar@app": Sidebar,
      "topbar@app": Topbar,
      "content@app": ConnectComponent2(View, Presenter)
    }
  }
];

const context = require.context("./", true, /\.\/[^/]+\/index\.jsx?$/);
const states = requireStates(context, initialStates);

export { states };



// WEBPACK FOOTER //
// ./src/components/app/support/company/company-show/index.js